/**
 * Marca (RN-74): tudo que toca o paciente usa "Médico Online"; ambientes internos usam "Azanas".
 * Logo oficial Azanas Health Tech (horizontal) em /public/logo-azanas-horizontal.png; o produto "Médico Online" vem como selo ao lado.
 */
export default function Brand({ kind = 'medicoonline' }: { kind?: 'medicoonline' | 'azanas' }) {
  return (
    <span className="brand-lockup">
      <img className="brand-logo" src="/logo-azanas-horizontal.png" alt="Azanas Health Tech" />
      {kind === 'medicoonline' && <span className="brand-product">Médico Online</span>}
    </span>
  );
}
